import { LOCALE_US_EN, LOCALES_USING_IMPERIAL_SYSTEM } from 'models/location/constants'

const convertIntoM = (inches) => {
    const meters = inches / 39.3701
    return meters
}

const convertCmtoM = (centimeters) => {
    const meters = centimeters / 100
    return meters
}

const convertMtoIn = (meters, round) => {
    const inches = 39.3701 * meters

    return round ? Math.ceil(inches * 8) / 8 : inches
}

const convertMtoCm = (dimensionMeters, round) => {
    const centimeters = dimensionMeters * 100

    return round ? Math.ceil(centimeters) : centimeters
}

export const convertMeterDimensionsByLocale = (dimensionMeters, locale = LOCALE_US_EN, round = true) =>
    LOCALES_USING_IMPERIAL_SYSTEM.includes(locale)
        ? convertMtoIn(dimensionMeters, round)
        : convertMtoCm(dimensionMeters, round)

export const convertDimensionsToMeterByLocale = (dimension, locale = LOCALE_US_EN) =>
    LOCALES_USING_IMPERIAL_SYSTEM.includes(locale) ? convertIntoM(dimension) : convertCmtoM(dimension)
